"use client";

import { JsonLdScript } from "next-seo";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqJsonLdProps {
  faqs: FaqItem[];
  /** Человекочитаемое имя блока (поле name у FAQPage для отчётов Search Console). */
  pageName?: string;
}

/** FAQ Schema для лучшего SEO - отображение вопросов в поисковой выдаче */
export default function FaqJsonLd({ faqs, pageName }: FaqJsonLdProps) {
  const mainEntity = faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  }));

  return (
    <JsonLdScript
      scriptKey="faq-page"
      data={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        ...(pageName ? { name: pageName } : {}),
        mainEntity,
      }}
    />
  );
}
